import { getLanguageCode } from './getApiUrl';

const LEGACY_TOKEN_KEY = 'token';
const LEGACY_PERMISSIONS_KEY = 'permissions';
const DEFAULT_STORAGE_SCOPE = 'default';

function getStorageScope() {
  return getLanguageCode() || DEFAULT_STORAGE_SCOPE;
}

function getScopedKey(baseKey) {
  return `${baseKey}:${getStorageScope()}`;
}

export function getTokenStorageKey() {
  return getScopedKey(LEGACY_TOKEN_KEY);
}

export function getPermissionsStorageKey() {
  return getScopedKey(LEGACY_PERMISSIONS_KEY);
}

export function getAuthToken() {
  return localStorage.getItem(getTokenStorageKey());
}

export function getAuthPermissions() {
  return localStorage.getItem(getPermissionsStorageKey());
}

export function setAuthSession(token, permissions) {
  localStorage.setItem(getTokenStorageKey(), token);
  localStorage.setItem(getPermissionsStorageKey(), permissions);

  // Remove legacy shared keys to prevent cross-language session leakage.
  localStorage.removeItem(LEGACY_TOKEN_KEY);
  localStorage.removeItem(LEGACY_PERMISSIONS_KEY);
}

export function clearAuthSession() {
  localStorage.removeItem(getTokenStorageKey());
  localStorage.removeItem(getPermissionsStorageKey());

  // Clean up historical shared keys left by previous builds.
  localStorage.removeItem(LEGACY_TOKEN_KEY);
  localStorage.removeItem(LEGACY_PERMISSIONS_KEY);
}
